import type { TemplateFormsState } from '../index';
import type { LayoutType } from 'types';
import { uniquifySectionNameOnTab } from '../utils/nameUniqueness';

interface Payload {
  layoutType: LayoutType;
  tabId: string;
}

export const removeTab = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { layoutType, tabId } = payload;
  const sections = state[layoutType].sections;
  const remainingTabs = state[layoutType].tabs.filter((tab) => tab.id !== tabId);
  const destinationTabId = [...remainingTabs].sort((a, b) => a.order - b.order)[0]?.id ?? null;

  const existingNames = new Set(sections.filter((section) => (section.tabId ?? null) === destinationTabId).map((section) => section.name));

  for (const section of sections) {
    if (section.tabId !== tabId) continue;
    uniquifySectionNameOnTab(section, existingNames);
    section.tabId = destinationTabId;
  }

  state[layoutType].tabs = remainingTabs;
};
